import { computed, ref } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import AiAPI from 'custom/api/ai';

// The account's AI settings, fetched once per account and shared by every screen that needs them
const byAccount = ref({});
const inFlight = {};

export function useAiSettings() {
  const accountId = useMapGetter('getCurrentAccountId');
  const settings = computed(() => byAccount.value[accountId.value] || null);
  const isConfigured = computed(() => Boolean(settings.value?.configured));

  const set = data => {
    byAccount.value = { ...byAccount.value, [accountId.value]: data };
  };

  const load = async ({ force = false } = {}) => {
    const id = accountId.value;
    if (!force && byAccount.value[id]) return byAccount.value[id];
    inFlight[id] ||= AiAPI.settings()
      .then(({ data }) => {
        byAccount.value = { ...byAccount.value, [id]: data };
        return data;
      })
      .finally(() => {
        delete inFlight[id];
      });
    return inFlight[id];
  };

  return { settings, isConfigured, load, set };
}
